export default {
  assumptionList: {
    method: 'post',
    url: '/client/costing/assumption/list'
  },
  assumptionDetail: {
    method: 'get',
    url: '/client/costing/assumption/detail/ID'
  },
  updateAssumption: {
    method: 'put',
    url: '/client/costing/assumption/update/ID'
  },
  createAssumption: {
    method: 'post',
    url: '/client/costing/assumption/create'
  },
  deleteAssumption: {
    method: 'DELETE',
    url: '/client/costing/assumption/delete/ID'
  }
}
